import Header from "./Header";
import Nav from "../Nav";
import Footer from "../Footer";
import FeatureHeadline from "./FeatureHeadline";
import CallToAction from "./CallToAction";
import Contact from "./Contact";
import Pricing from "../Pricing";
import Carousel from "./Carousel";
import './style.css'

const Home = () => (
	<>
		<div className="bg-white">
			<Nav />
			<Header />
			<FeatureHeadline />
			<CallToAction />
			<Pricing />
			<Carousel />
			<Contact />
			<Footer />
		</div>
	</>
);

export default Home;
